export function openReviewOutboundUrl(url) {
  const u = (url || "").trim();
  if (!u) return;
  const tg = window.Telegram?.WebApp;
  if (typeof tg?.openLink === "function") {
    tg.openLink(u);
  } else {
    window.open(u, "_blank", "noopener,noreferrer");
  }
}

export function promoSuccessMessage(res) {
  const base = res?.bonus_awarded ?? 0;
  const triple = res?.triple_bonus_awarded ?? 0;
  let s =
    base > 0
      ? `Готово! Начислено ${base} бонусов.`
      : "Готово.";
  if (triple > 0) {
    s += ` Бонус за все четыре шага: ещё +${triple} бонусов.`;
  }
  return s;
}
